let optionClickHandler = async (option) => {
	let res = await fetch(`/?section_id=cascade-${option}-product-section`);
	let text = await res.text();

	let box = document.getElementById('cascade-buybox');
	document.getElementById('cascade-buybox').innerHTML = text;

	let activeColor = document.querySelector(`input[value=${option}]`);
	activeColor.setAttribute('checked', 'true');

	// Remove any existing script with this src
	document.querySelectorAll('script[src*="product.js"]').forEach((script) => script.remove());

	let newScript = document.createElement('script');
	newScript.type = 'text/javascript';
	// newScript.src = 'https://protalus.com/cdn/shop/t/45/assets/product.js?v=178912185591868184461747437759';
	newScript.src = "{{ 'product.js | asset_url }}";
	box.appendChild(newScript);
	setColorOptionsEventLister();
};

let setColorOptionsEventLister = () => {
	let colorOptions = Array.from(document.getElementsByClassName('color-option'));
	colorOptions.forEach((option) => {
		option.addEventListener('click', () => optionClickHandler(option.getAttribute('data-option-name')));
	});
};
optionClickHandler('brown');
setColorOptionsEventLister();
